var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelecaller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24424_5413)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6025 15.1758C19.6843 14.7298 20.8677 14.5948 22.0195 14.7822L22.249 14.8232C23.4726 15.0691 24.5961 15.6732 25.4766 16.5576V16.5566C25.9851 17.0676 26.4014 17.6623 26.707 18.3135L26.8311 18.5967C27.1048 19.2635 27.2613 19.9719 27.2939 20.6904L27.2998 20.999V26C27.2998 26.5335 27.1144 27.0479 26.7793 27.457L26.626 27.626C26.1947 28.0572 25.6099 28.2998 25 28.2998H21.5C21.4404 28.2998 21.3829 28.2816 21.334 28.249L21.2881 28.2119C21.2319 28.1557 21.2003 28.0795 21.2002 28C21.2002 27.9403 21.2174 27.8819 21.25 27.833L21.2881 27.7881C21.3443 27.7318 21.4204 27.7002 21.5 27.7002H25C25.3945 27.7002 25.7746 27.5623 26.0771 27.3145L26.2021 27.2021C26.5209 26.8834 26.7001 26.4508 26.7002 26V25.7998H25C24.6553 25.7998 24.3248 25.6627 24.0811 25.4189C23.8373 25.1752 23.7003 24.8447 23.7002 24.5V22C23.7002 21.6552 23.8373 21.3239 24.0811 21.0801C24.3248 20.8365 24.6554 20.7002 25 20.7002H26.6973L26.6777 20.4814C26.5919 19.539 26.2725 18.635 25.752 17.8496L25.5166 17.5205C24.9391 16.7707 24.1855 16.1782 23.3252 15.7939L22.9502 15.6416C22.0609 15.318 21.107 15.2219 20.1748 15.3584L19.7764 15.4316C18.852 15.6349 17.9952 16.0648 17.2812 16.6797L16.9844 16.9541C16.0897 17.8371 15.5159 18.991 15.3506 20.2324L15.3232 20.4824L15.3037 20.7002H17C17.3446 20.7002 17.6752 20.8365 17.9189 21.0801C18.1627 21.3239 18.2998 21.6552 18.2998 22V24.5C18.2997 24.8447 18.1627 25.1752 17.9189 25.4189C17.6752 25.6627 17.3447 25.7998 17 25.7998H16C15.6983 25.7998 15.4071 25.6954 15.1758 25.5059L15.0811 25.4189C14.8373 25.1752 14.7003 24.8447 14.7002 24.5V21L14.7041 20.7666C14.7485 19.6005 15.1163 18.468 15.7676 17.4961C16.4623 16.4595 17.4489 15.6515 18.6025 15.1758Z",
    fill: "#0F5EFF",
    stroke: "#0F5EFF",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24424_5413",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_24424_5413"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24424_5413"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24424_5413",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelecaller);
export default __webpack_public_path__ + "static/media/telecaller.fa5aa842e391b1a0f1246318704774de.svg";
export { ForwardRef as ReactComponent };